import React from "react";

const Cookie = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                <h4 className="title_text text-dark mb-3">TopCoin UK Ltd - Cookie Policy</h4>
                <p className="text-dark fw-semibold opacity-50 mb-0">Effective Date: 6 September 2026</p>
                <p className="text-dark fw-semibold opacity-50 mb-0">Company Registration No.: 16483297</p>
                <p className="text-dark fw-semibold opacity-50 mb-3">Email: info@topcoinuk.com</p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">1. Introduction</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  This Cookie Policy explains how TopCoin UK Ltd ("TopCoin UK", "we", "us" or "our") uses cookies and similar technologies when you visit or use the TopCoin UK website and platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Cookies and similar technologies may be used to operate and secure our website, maintain account and wallet functionality, remember preferences, understand how our Services are used and, where applicable, support analytics and other permitted purposes.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  This Cookie Policy should be read together with the TopCoin UK Privacy Policy.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">2. What Are Cookies?</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Cookies are small files or pieces of information that may be stored on or accessed from your computer, smartphone, tablet or other device when you visit a website.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Cookies can help a website recognise a device, maintain a login session, remember preferences and provide information about how the website is being used.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Similar technologies may also be used to store or access information on a user's device.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">3. Types of Cookies and Similar Technologies We May Use</h5>
                <p className="info_description text-dark opacity-50 mb-3">TopCoin UK may use the following categories:</p>

                <h6 className="text-dark fw-bold">Strictly Necessary Cookies</h6>
                <p className="info_description text-dark opacity-50 mb-2">
                  These are used where necessary to operate the TopCoin UK website and provide Services requested by the user. They may be used for account login and authentication; TopCoin Wallet access; Captain TC Rewards Wallet access; Captain TC Gold Wallet access; website and account security; fraud prevention; maintaining essential sessions; and remembering essential selections required to provide a requested service.
                </p>
                <p className="info_description text-dark opacity-50 mb-3">
                  Where applicable legal requirements allow, these technologies may be used without consent because they are necessary for the requested service or fall within another applicable exception.
                </p>

                <h6 className="text-dark fw-bold">Functional or Preference Technologies</h6>
                <p className="info_description text-dark opacity-50 mb-3">
                  These may remember choices such as language, display preferences or other website settings. Where an applicable legal exception is available, these technologies may be used in accordance with that exception and the required user controls. Otherwise, consent will be obtained where required.
                </p>

                <h6 className="text-dark fw-bold">Analytics or Statistical Technologies</h6>
                <p className="info_description text-dark opacity-50 mb-3">
                  These may help TopCoin UK understand how visitors use the website, such as which pages are visited and how customers interact with the platform. Where an applicable statistical-purpose exception can lawfully be relied upon, TopCoin UK will provide the required information and a simple means for users to object. Where that exception does not apply, TopCoin UK will obtain consent before using the relevant analytics or statistical technologies.
                </p>

                <h6 className="text-dark fw-bold">Advertising and Marketing Technologies</h6>
                <p className="info_description text-dark opacity-50 mb-0">
                  If TopCoin UK uses cookies or similar technologies for online advertising, advertising measurement, tracking or profiling, these will only be used where the required consent has been obtained.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">4. How We Use Cookies</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Depending on the technologies implemented on the TopCoin UK website, we may use cookies and similar technologies to:
                </p>
                <ul className="text-dark opacity-50 ms-4" style={{ listStyleType: "disc" }}>
                  <li>Maintain secure account login sessions;</li>
                  <li>Enable access to the TopCoin Wallet;</li>
                  <li>Enable access to the Captain TC Rewards Wallet;</li>
                  <li>Enable access to the Captain TC Gold Wallet;</li>
                  <li>Protect accounts and the platform against fraud and misuse;</li>
                  <li>Maintain website security;</li>
                  <li>Remember applicable customer preferences;</li>
                  <li>Understand how customers use the TopCoin UK platform;</li>
                  <li>Monitor and improve website performance;</li>
                  <li>Diagnose technical problems; and</li>
                  <li>Support analytics, advertising or marketing where permitted and subject to the required choices or consent.</li>
                </ul>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">5. Captain TC and Wallet Services</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK's website may use necessary technologies to support account-based services, including the <strong>TopCoin Wallet, Captain TC Rewards Wallet and Captain TC Gold Wallet.</strong>
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  For example, technologies may be necessary to authenticate a customer, maintain a secure session and provide access to requested wallet functionality.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The use of cookies for security, fraud prevention and authentication may fall within applicable legal exceptions where the relevant requirements are satisfied.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">6. Third-Party Technologies</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may use third-party providers to support functions such as website hosting, analytics, security, payments, affiliate or transaction tracking and other platform services.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Some third-party providers may place or access cookies or similar technologies on your device where applicable.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where required, TopCoin UK will identify relevant third parties and explain the purposes for which their technologies are used.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Third parties may process information according to their own privacy and cookie policies where they act independently.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK will not permit non-essential third-party technologies requiring consent to be activated before the required consent has been obtained.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">7. Cookie Consent and Your Choices</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  When you visit the TopCoin UK website, you may be presented with cookie controls allowing you to make choices concerning cookies and similar technologies.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where consent is required, TopCoin UK will seek consent before activating the relevant non-essential technologies.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  You should be able to reject or manage technologies requiring consent without losing access to website functionality that does not depend upon those technologies.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where consent is legally required, consent must involve a clear positive choice; simply continuing to use the website will not by itself be treated as consent.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">8. Changing Your Cookie Preferences</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where TopCoin UK provides cookie settings or a consent-management facility, you may use those controls to review or change your preferences.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  You can also use your browser settings to manage cookies, including deleting or blocking cookies.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  However, disabling technologies that are necessary for account login, security, wallet access or other requested functionality may prevent parts of the TopCoin UK platform from operating correctly.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">9. Cookie Duration</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Cookies and similar technologies may be either:
                </p>
                <ul className="text-dark opacity-50 ms-4 mb-2" style={{ listStyleType: "disc" }}>
                  <li><strong>Session technologies</strong> - generally operating only for the duration of a browser session; or</li>
                  <li><strong>Persistent technologies</strong> - remaining for a defined period unless deleted earlier.</li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-2">
                  The duration depends on the purpose and technology concerned.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK will periodically review the technologies used and their retention periods to ensure they remain appropriate.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">10. Personal Information and Cookies</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Some information collected through cookies and similar technologies may constitute personal information or become personal information when combined with other information.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where personal information is processed, the <strong>TopCoin UK Privacy Policy</strong> explains how TopCoin UK handles that information and the rights available to customers under applicable data-protection law.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">11. Changes to This Cookie Policy</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may update this Cookie Policy from time to time to reflect changes to the TopCoin UK platform, Captain TC services, technologies used on the website, third-party service providers or applicable legal and regulatory requirements.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The latest version will be published on the TopCoin UK website with its effective or updated date.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">12. Contact Us</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  If you have questions about TopCoin UK's use of cookies or similar technologies, please contact:
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  <strong>TopCoin UK Ltd</strong><br />
                  Company Registration No.: 16483297<br />
                  Email: <strong>info@topcoinuk.com</strong>
                </p>
              </li>
              
              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2 mt-4">
                 <div className="alert alert-secondary text-dark opacity-75 border-0">
                  <p className="mb-0">
                    <strong>Website implementation note:</strong> This policy should be kept consistent with the cookies and similar technologies actually used by the TopCoin UK website. Where applicable, the website's cookie controls or cookie information should identify the relevant technologies, their providers, purposes and durations.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cookie;
